<template>
  <div :class="$style.modal">
    <div :class="$style.modalContent">
      <ModalHeader
        :handleClose="handleClose"
        headerText="Register WebAuthn Security Key"
      />
      <div :class="$style.modalBody">
        <MessageContainer
          v-if="informationMessage"
          :level="$options.info"
        >
          {{ informationMessage }}
        </MessageContainer>
        <p>Please follow the steps below to register your security key.</p>
        <div :class="[$style.flexContainer, $style.instructions]">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 88" :class="[$style.half, $style.img]" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><g transform="translate(17.5)"><path fill="#161F27" fill-rule="nonzero" d="M120.18 3.57V65a3.21 3.21 0 01-3.24 3.215H21.075a3.2 3.2 0 01-3.23-3.21V3.675a3.23 3.23 0 013.23-3.21L116.94.36a3.23 3.23 0 013.24 3.21z"/><path fill="#161F27" fill-rule="nonzero" d="M120.18 59.89V65a3.21 3.21 0 01-3.24 3.215H21.075a3.2 3.2 0 01-3.23-3.21V59.88l102.335.01z"/><path fill="#F2F2F2" fill-rule="nonzero" d="M71.115 64.03a2.155 2.155 0 11-2.155-2.135 2.145 2.145 0 012.155 2.135z"/><path fill="#F1F3F4" fill-rule="nonzero" d="M115.705 59.695H22.61V8.5a3.23 3.23 0 013.23-3.215l86.625-.085a3.235 3.235 0 013.24 3.215v51.28z" opacity=".95"/><rect width="37" height="5" x="51" y="22" fill="#626B73" rx="1"/><rect width="37" height="5" x="51" y="29" fill="#626B73" rx="1"/><rect width="21" height="5" x="59" y="38" fill="#626B73" rx="2.5"/><path fill="#161F27" fill-rule="nonzero" d="M136.38 84.625L1.69 84.55a1.595 1.595 0 01-1.115-2.74L17.54 67.365c.3-.289.7-.45 1.115-.45h100.68c.418-.001.82.16 1.12.45l17.045 14.5a1.59 1.59 0 01-1.12 2.76z"/><path fill="#626B73" fill-rule="nonzero" d="M23.695 71.56H19.67l2.905-3.03h3.795zm5.71 0h-4.03l2.575-3.03h3.795zm5.71.005l-4.03-.005 2.24-3.03h3.795zm5.705 0h-4.03l1.91-3.035 3.8.005zm5.715 0H42.5l1.58-3.03h3.795zm5.71.005l-4.03-.005 1.245-3.03h3.795zm5.715 0h-4.035l.915-3.035h3.795zm5.715 0H59.64l.58-3.03h3.8zm5.715.005h-4.035l.245-3.035h3.8zm5.72 0h-4.035l-.09-3.035h3.8zm5.715.005l-4.035-.005-.42-3.035 3.8.005zm5.72 0H82.51l-.755-3.035h3.8zm5.725 0h-4.04l-1.09-3.035h3.805zm5.72.005l-4.04-.005-1.42-3.035h3.8zm5.725 0h-4.04l-1.76-3.035h3.805zm5.725 0h-4.04l-2.095-3.035h3.805zm5.725.005h-4.04l-2.425-3.04h3.805zm5.73 0h-4.045l-2.76-3.04 3.805.005zm-101.32 4.645h-4.39l3.435-3.58h4.11zm6.22.005l-4.395-.005 3.045-3.58h4.115zm6.22 0H27.62l2.655-3.585 4.11.005zm6.22.005l-4.39-.005 2.255-3.58h4.115zm6.225 0h-4.39l1.86-3.585h4.12zm6.23.005l-4.395-.005 1.47-3.58h4.115zm6.225 0H52.52l1.075-3.585h4.12zm6.23.005l-4.395-.005.68-3.585 4.12.005zm6.23 0H64.98l.285-3.585h4.125zm6.235.005l-4.4-.005-.105-3.585h4.12zm6.23 0h-4.4l-.5-3.585h4.125zm6.235.005l-4.4-.005-.895-3.585h4.125zm6.24 0H89.91l-1.285-3.59 4.125.005zm6.235.005l-4.4-.005-1.685-3.585h4.125zm6.24 0h-4.405l-2.075-3.59 4.125.005zm6.245.005l-4.41-.005-2.47-3.585h4.125zm12.485.005l-10.65-.005-2.87-3.59 9.975.005zM14.635 81.835H9.81l4.12-4.3 4.495.005zm6.83.005l-4.82-.005 3.65-4.295h4.49zm6.84.005l-4.83-.005 3.18-4.295h4.495zm6.835 0h-4.825l2.71-4.3h4.49zm6.84.005l-4.825-.005 2.235-4.295h4.495zm6.84.005l-4.83-.005 1.77-4.3 4.495.005zm40.285.02l-38.27-.02 1.29-3.965 35.63.015zm7.66.005l-4.84-.005-1.545-4.305 4.505.005zm6.855 0h-4.84l-2.02-4.305h4.505zm6.86.005h-4.845l-2.49-4.31 4.505.005zm6.86.005l-4.845-.005-2.965-4.305h4.505zm13.725.005l-11.71-.005-3.44-4.31 10.895.005z"/><path fill="#000" fill-rule="nonzero" d="M138.11 82.89v4.38c0 .325-.245.525-.82.525L.815 87.71c-.57 0-.815-.21-.815-.53v-4.37c.04.285.285 1.5.815 1.5l136.5.08c.51-.01.755-1.215.795-1.5z"/></g><path fill="#414C55" d="M6 69v-7.5h7.5V69z"/><path fill="#2CC692" fill-rule="nonzero" d="M9.987 62.45c-1.443-.002-2.615 1.196-2.617 2.675-.002 1.48 1.166 2.681 2.608 2.683 1.443.003 2.615-1.195 2.617-2.674.002-1.48-1.165-2.68-2.608-2.683zm-7.369 3.84c.631 0 1.144-.524 1.145-1.17 0-.648-.51-1.173-1.141-1.174-.631-.001-1.144.523-1.145 1.17 0 .647.51 1.172 1.141 1.173zM0 69.902l.015-9.336A.562.562 0 01.569 60l17.181.028a.564.564 0 01.553.569l-.002 1.137 5.147.008a.56.56 0 01.552.569l-.01 5.927a.577.577 0 01-.163.402.544.544 0 01-.39.165l-5.147-.009-.002 1.138a.562.562 0 01-.554.566L.552 70.472A.562.562 0 010 69.903z"/></g></svg>
          <ol :class="[$style.half, $style.steps]">
            <li :class="$style.step">
              <span :class="$style.stepText">
                <strong>Enter</strong> display name below, if desired.
              </span>
            </li>
            <li :class="$style.step">
              <span :class="$style.stepText">
                <strong>Click</strong> register key.
              </span>
            </li>
            <li :class="$style.step">
              <span :class="$style.stepText">
                <strong>Insert</strong> key into computer, and if applicable, click button on key.
              </span>
            </li>
          </ol>
        </div>
        <InputValidator
          :config="{
            dataLpignore: true,
            label: 'Display Label',
            name: 'Display Label',
            placeholder: '[Optional] This may help distinguish between multiple keys',
            validate: 'max:255',
          }"
          @InputValidatorModel="handleNameChange"
        />
      </div>
      <ModalFooter
        cancelText="cancel"
        :enableMainAction="enableMainAction"
        :handleClose="handleClose"
        :handleMainAction="handleMainAction"
        :kbLink="kbLink"
        mainActionText="register key"
      />
    </div>
  </div>
</template>
<script>
import * as Constants from 'client/util/Constants';
import { mapActions } from 'vuex';
import { notify } from 'client/util';
import InputValidator from 'client/components/FormValidation/InputValidator.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import MessageContainer from 'client/components/MessageContainer/MessageContainer.vue';
import ModalEventBus, { ModalEvents } from 'client/components/Modal/ModalEventBus';
import ModalFooter from 'client/components/Modal/ModalComponents/ModalFooter.vue';
import ModalHeader from 'client/components/Modal/ModalComponents/ModalHeader.vue';

const { ItemTypeConsts, StoreModelMap } = Constants;
const { error, success, info } = Constants.default;
const systemUserWebAuthKeysModel = StoreModelMap[ItemTypeConsts.systemUserWebAuthnKeys];

export default {
  name: 'RegisterWebAuthnKeyModal',

  components: {
    InputValidator,
    MessageContainer,
    ModalFooter,
    ModalHeader,
  },

  inject: ['$validator'],

  info,

  data() {
    return {
      name: '',
      enableMainAction: true,
      informationMessage: '',
    };
  },

  created() {
    this.kbLink = KbArticleUrls.webAuthn;
  },

  methods: {
    ...mapActions(systemUserWebAuthKeysModel, [
      'addWebAuthnKey',
      'fetchPublicKeyCredentialsCreationOptions',
      'registerPublicKeyCredential',
    ]),

    /**
     * This wrapper method exists so global methods can be stubbed in unit tests.
     */
    createCredentials(publicKeyCreationOptions) {
      return navigator.credentials.create(publicKeyCreationOptions);
    },

    handleClose() {
      ModalEventBus.close();
    },

    async handleMainAction() {
      try {
        this.informationMessage = 'Please insert your security key into your device';
        const { publicKey, token } = await this.fetchPublicKeyCredentialsCreationOptions();
        const publicKeyCredential = await this.createCredentials({ publicKey });

        const webAuthnKey = await this.registerPublicKeyCredential({
          token,
          name: this.name,
          publicKeyCredential,
        });

        this.addWebAuthnKey(webAuthnKey);

        ModalEventBus.$once(ModalEvents.transitionEnd, () => {
          notify(success, 'WebAuthn Security Key has been successfully registered');
        });

        ModalEventBus.close();
      } catch (exp) {
        notify(error, `Unable to register WebAuthn Security key: ${exp.message}`);
      } finally {
        this.informationMessage = '';
      }
    },

    async handleNameChange(value) {
      this.name = value;
      await this.$validator.validate('Display Label');
      this.enableMainAction = this.v2Errors.items.length === 0;
    },
  },
};
</script>
<style module>
@import '../../components/Modal/css/ModalStyles.css';
@import '../../css/flex.css';

@value (blue) from '~css/colors.css';

.instructions {
  margin: 40px 0 40px 0;
}

.img {
  height: 120px;
}

.steps {
  font-size: 13px;
  list-style-type: none;
  padding-left: 0;
}

.step {
  counter-increment: step-counter;
  font-weight: 300;
  margin-bottom: 15px;
  position: relative;
  text-align: left;
  white-space: normal;
}

.step::before {
  background-color: blue;
  border-radius: 8px;
  color: white;
  content: counter(step-counter);
  display: inline-block;
  font-weight: 400;
  height: 17px;
  left: 0;
  line-height: 17px;
  position: absolute;
  text-align: center;
  top: 0;
  width: 17px;
}

.stepText {
  display: inline-block;
  padding-left: 25px;
}
</style>
